var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBreakLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10606_106373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9858 3H2V4.43627H27.9858V3Z",
    fill: "#2D2F37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2257 20.4062H2V21.8425H12.2257V20.4062Z",
    fill: "#2D2F37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0315 11.8125H2.05371V13.2488H23.0387C23.9316 13.3188 24.7656 13.7263 25.3739 14.3899C25.9822 15.0536 26.3201 15.9245 26.3201 16.8287C26.3201 17.7329 25.9822 18.6038 25.3739 19.2674C24.7656 19.931 23.9316 20.3386 23.0387 20.4086H17.7035L22.0783 16.3044L21.1073 15.2524L14.8296 21.1267L21.086 27.001L22.057 25.9489L17.6857 21.8448H23.0209C24.2824 21.7613 25.4652 21.1965 26.3295 20.265C27.1937 19.3335 27.6745 18.1049 27.6745 16.8287C27.6745 15.5524 27.1937 14.3239 26.3295 13.3923C25.4652 12.4608 24.2824 11.896 23.0209 11.8125H23.0315Z",
    fill: "#2D2F37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10606_106373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 24,
    fill: "white",
    transform: "translate(2 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBreakLine);
export default __webpack_public_path__ + "static/media/ic_break_line.6d422460695e3321fffd4914308c11ca.svg";
export { ForwardRef as ReactComponent };